import {
  CommonEntitiesListResponse,
  CountryCreationDto,
} from '@docbay/schemas';
import axiosInstance from 'integration/api/axiosInstance';
import { SupportedCountriesDto } from 'common/types/countries';

/**
 * API methods for countries.
 */
export const CountriesAPI = {
  /**
   * Retrieves a list of supported countries.
   *
   * @returns A promise that resolves to the response containing
   *          a list of supported countries.
   */
  getSupportedCountries: async () => {
    return await axiosInstance.get<
      CommonEntitiesListResponse<SupportedCountriesDto>
    >('/countries/supported');
  },

  /**
   * Retrieves a list of all countries.
   *
   * @returns A promise that resolves to the response containing
   *          a list of all countries.
   */
  getAllCountries: async () => {
    return await axiosInstance.get<
      CommonEntitiesListResponse<SupportedCountriesDto>
    >('/countries');
  },

  /**
   * Adds a new country to the list of supported countries.
   *
   * @param params - The creation data for the new country.
   *
   * @returns A promise that resolves to the response containing
   *          the newly created country.
   */
  addToSupportedCountries: async (params: CountryCreationDto) => {
    return await axiosInstance.post<CountryCreationDto>(
      '/countries/supported',
      params,
    );
  },

  /**
   * Deletes a supported country from the list of supported countries.
   *
   * @param isoCode - The ISO code of the country to delete.
   *
   * @returns A promise that resolves to the response containing
   *          the result of the deletion operation.
   */
  deleteSupportedCountry: async (isoCode: string) => {
    return await axiosInstance.delete(`/countries/supported/${isoCode}`);
  },
};
